import { Component, OnInit, ViewChild, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

import { ChartConfiguration, ChartData, ChartEvent, ChartType } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'app-chartjs-bar',
  templateUrl: './chartjs-bar.component.html',
  styleUrls: ['./chartjs-bar.component.scss']
})
export class ChartjsBarComponent implements OnInit {

  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  @Input() chartHeight: any = 60; // Chart height in pixel
  @Input() chartOptions: any = { // Chart options
    responsive: true,
      indexAxis: 'y',
      maintainAspectRatio: false,
      scales: {
        x: {
          display: false
        },
        y: {
          display: false
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: true,
          displayColors: false,
        }
      }
  }
  @Input() chartData: any; // Chart data

  public chartType: ChartType = 'bar';
  public barChartOptions: ChartConfiguration['options'];
  public barChartData: ChartData<'bar'>;

  constructor() { }

  ngOnInit(): void {
    // Set bar chart options
    this.barChartOptions = {
      responsive: this.chartOptions.responsive,
      indexAxis: this.chartOptions.indexAxis,
      maintainAspectRatio: this.chartOptions.maintainAspectRatio,
      scales: {
        x: {
          display: this.chartOptions.scales.x.display
        },
        y: {
          display: this.chartOptions.scales.y.display
        },
      },
      plugins: {
        legend: {
          display: this.chartOptions.plugins.legend.display,
        },
        tooltip: {
          enabled: this.chartOptions.plugins.tooltip.enabled,
          displayColors: this.chartOptions.plugins.tooltip.displayColors
        }
      }
    };

    // Set bar chart data
    this.barChartData = this.chartData;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['chartData']) {
      this.barChartData = this.chartData;
    }
  }

}
